import './core'
import { Popup, Carousel_CoreInit, Form_CoreInit, Mobile, Accordion, AjaxifyGrid_CoreInit } from './core'
import Header from './modules/header'
import Fancybox from '@fancyapps/fancybox'
import './plugins/scroll-to-anchor'
import './plugins/rolling-banner'
import './plugins/google-map'
import './plugins/packages'
import './plugins/same-height-grid'

AjaxifyGrid_CoreInit()

Carousel_CoreInit([
  {
    classSelector: 'carousel--style--gallery-spaced',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 1.333,
        },
        768: {
          slidesPerView: 'auto',
        }
      },
      on: {
        resize:  function(carousel) {
          carousel.params.spaceBetween = $(carousel.$el).width() * 25 / 100;
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--gallery',
    swiperOptions: {
      slideToClickedSlide: true,
      breakpoints: {
        0: {
          slidesPerView: 1.333,
        },
        768: {
          loopedSlides: 3,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--default',
    swiperOptions: {
      loopedSlides: 3,
      breakpoints: {
        0: {
          slidesPerView: 1.333,
        },
        768: {
          loopedSlides: 3,
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--mixed-media',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 1.333,
        },
        768: {
          slidesPerView: 'auto',
        }
      },
      on: {
        beforeInit: function (swiper) {
          $('.--text-only').each(function() {
            $(this).closest('.grid__item').addClass('grid__item--text-only')
          })
        },
        resize:  function(carousel) {
          carousel.params.spaceBetween = $(carousel.$el).width() * 8.33333 / 100;
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--testimonial',
    swiperOptions: {
      breakpoints: {
        768: {
          slidesPerView: 'auto',
        }
      },
      on: {
        resize:  function(carousel) {
          carousel.params.spaceBetween = $(carousel.$el).width() * 25 / 100;
        },
      },
    },
  },
])

Form_CoreInit([
  {
    classSelector: 'builder-form',
    formOptions: {
      floating_labels: true,
    },
  }
])

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    scroll: $(window).ScrollEvents(),
  }

  Header.init()

  /* Accordions */
  Accordion.init()

  /* Popup messages */
  Popup.init({
    click_outside: false,
  })

  /* Create a menu out of titles in content */
  $('.table-of-contents a').each(function() {
    $(this).scrollToAnchor();
  })

  /* Scroll to anchors */
  $('a[href^=#]').each(function() {
    $(this).scrollToAnchor()
  })

  /* Make anchor menu stick to the left when we scroll */
  $('.fixed-content').each(function() {
    $('<div class="fixed-content__end"></div>').insertAfter($(this).closest('.row'));
    if ($(this).find('.text-content').length) {
      let fixedContent = $(this).find('.text-content').FixedContent({
        topBlocker: $('.header'),
        limitFromTop: 30,
        mobile: false,
        bottomBlocker: $(this).closest('.row').next('.fixed-content__end'),
      })
    }
  })

  $('.single-post__sidebar__content').each(function() {
    if ($(this).closest('.row').next('.fixed-content__end').length) {
      $(this).FixedContent({
        topBlocker: $('.header'),
        limitFromTop: 30,
        mobile: false,
        bottomBlocker: $(this).closest('.row').next('.fixed-content__end'),
      });
    }
  })

  /* Rolling text in footer */
  $('.rolling-text').each(function() {
    $(this).RollingBanner()
  })

  /* Link following cursor */
  $('.btn-cursor').each(function() {
    $(this).attr('data-title', $(this).attr('title'))
    $(this).removeAttr('title');
  });

  $(document).on('mousemove', function(e) {
    $('.btn-cursor').each(function() {
      if ($(this).hasClass('card-gallery')) {
        $(this).css({
          '--left': (e.clientX - $(this).offset().left) + 'px',
          '--top': (e.clientY - $(this).offset().top + $(window).scrollTop()) + 'px',
        })
      } else {
        $(this).css({
          '--left': e.clientX + 'px',
          '--top': e.clientY + 'px',
        })
      }
    })
  });

  /* Contact map */
  $('.contact-map').each(function() {
    $(this).ContactMap()
  })

  /* Packages */
  $('.packages').each(function() {
    $(this).Packages()
  })

  /* Force project image height */
  $('.grid--col-6.grid--postitem__project').each(function() {
    $(this).sameHeightGrid(1);
  })

  $('.grid--col-5.grid--postitem__project').each(function() {
    $(this).sameHeightGrid(4);
  })

  /* Search floating label */
  $('.grid-search .field').FloatingLabel();


  /* Video loop */
  $('.video-loop').each(function() {
    $(this).VideoLoop()
  })

  $('.bg-video').each(function() {
    $(this).VideoBg();
  })

  /* Banner resize */
  function resizeBanners() {
    $('.banner').each(function() {
      if (!$.mlmi.mobile.isMobile) {
        if ($(this).outerWidth(false) > parseFloat(getComputedStyle(document.body).fontSize) * 72) {
          $(this).removeClass('banner--narrow')
        } else {
          $(this).addClass('banner--narrow')
        }
      }
    })
  }
  $(window).on('load resize orientationchange', resizeBanners)
  resizeBanners()

  /* Carousel arrows resize */
  function repositionArrows() {
    $('.carousel--style--gallery').each(function() {
      $(this).css('--thumbnail-height', ($(this).find('.card-gallery .picture').outerHeight(false) / 2) + 'px')
    })
  }
  $(window).on('load resize orientationchange', repositionArrows)
  repositionArrows()

  /* Fancybox */
  $('[data-fancybox]').fancybox({
    loop: true,
    buttons: ['close'],
    transitionEffect: 'slide',
    i18n: {
      fr: {
        CLOSE: "Fermer",
        NEXT: "Photo suivante",
        PREV: "Photo précédente",
      },
    },
    lang: 'fr',
    backFocus: false,
  })
})
